export default __webpack_public_path__ + "static/media/Wristwraps of Fiendish Invocation.809ee745.jpg";